import { useMemo } from 'react';
import type { TradingStrategy } from '@einhaus/project314-types';
import { trpcUnbatched } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for the user's trading strategies, using the app-standard
 * transient retry and stale time behaviour. React Query dedupes the underlying
 * request, so any number of components can use this hook without extra fetches.
 */
export const useTradingStrategies = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpcUnbatched.strategy.fetchStrategies.queryOptions({ ids: [], requireActive: false }),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const strategies: TradingStrategy[] = useMemo(() => query.data?.strategies ?? [], [query.data?.strategies]);

    return { error: query.error, isLoading: query.isLoading, query, strategies };
};
